export default "__VITE_ASSET__BIx9YjBZ__"